{
    let copy_btn = document.querySelector('[data-copy]');

    if (copy_btn !== null) {
        let check_icon = 'icon-check';
        let copy_icon = 'icon-copy';

        copy_btn.addEventListener('click', e => {
            let icon = e.target;
            let el = icon.closest('[data-copy]');
            let content = el.dataset.copy;
            navigator.clipboard.writeText(content);

            icon.classList.remove(copy_icon);
            icon.classList.add(check_icon)

            setTimeout(() => {
              icon.classList.remove(check_icon);
              icon.classList.add(copy_icon);
            }, 1000);
        });
    }
}
